"use client";

import { Icon } from "@iconify/react";

interface JobCardProps {
  title: string;
  company: string;
  location: string;
  salary: string;
}

const JobCard = ({ title, company, location, salary }: JobCardProps) => {
  return (
    <div className="bg-[#F8FAFB] dark:bg-foreground-50 border-[0.5px] rounded-2xl px-4 py-3 flex flex-col gap-3 border border-[#E1E4EA] dark:border-foreground-200">
      <div className="flex items-center gap-3 mb-[13px]">
        <div className="flex items-center justify-center p-[5.14px] bg-white dark:bg-foreground-100 border-[0.5px] border-foreground-200 dark:border-foreground-200 rounded-lg">
          <Icon className="text-primary text-xl" icon="ri:building-fill" />
        </div>
        <div>
          <div className="text-black dark:text-foreground-950 font-medium text-sm leading-5 tracking-[-0.084px]">
            {title}
          </div>
          <div className="text-foreground-700 dark:text-foreground-600 text-xs font-normal leading-4">
            {company}
          </div>
        </div>
      </div>

      {/* Tags */}
      <div className="flex items-center gap-2 flex-wrap text-xs mb-[14px]">
        <span className="flex items-center gap-1 bg-primary-50 dark:bg-primary-50 font-normal text-primary px-2 py-1 rounded-2xl">
          <Icon className="text-xs" icon="ri:map-pin-fill" />
          {location}
        </span>

        <span className="flex items-center gap-1 bg-primary-50 dark:bg-primary-50 font-normal text-primary px-2 py-1 rounded-2xl">
          {salary}
        </span>
      </div>

      {/* Action */}
      <button className="text-primary dark:text-primary text-sm font-normal hover:underline w-fit tracking-[-0.084px] leading-5">
        Apply for job
      </button>
    </div>
  );
};

export default JobCard;
